"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Matboards = exports.getMatboard = void 0;
function getMatboard(id) {
    return exports.Matboards.find(matboard => matboard.id === id);
}
exports.getMatboard = getMatboard;
exports.Matboards = [
    {
        id: "beige",
        name: "Beige",
        hex: "#D3BE99",
        active: false,
    },
    {
        id: "black",
        name: "Black",
        hex: "#222222",
        active: true,
    },
    {
        id: "cactus",
        name: "Cactus",
        hex: "#A6E6C6",
        active: false,
    },
    {
        id: "caribbean",
        name: "Caribbean",
        hex: "#C2D2D2",
        active: true,
    },
    {
        id: "lilac",
        name: "Lilac",
        hex: "#D8A0EA",
        active: false,
    },
    {
        id: "driftwood",
        name: "Driftwood",
        hex: "#ACAA9E",
        active: true,
    },
    {
        id: "printed",
        name: "Printed Map",
        active: true,
    },
    {
        id: "sienna",
        name: "Sienna",
        hex: "#734649",
        active: true,
    },
    {
        id: "white",
        name: "White",
        hex: "#FFFFFF",
        active: true,
    },
    {
        id: "zucchini",
        name: "Zucchini",
        hex: "#545F51",
        active: true,
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWF0Ym9hcmRMaWJyYXJ5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJvZHVjdC90YmwvTWF0Ym9hcmRMaWJyYXJ5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFXQSxTQUFnQixXQUFXLENBQUMsRUFBVTtJQUNwQyxPQUFPLGlCQUFTLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLEVBQUUsS0FBSyxFQUFFLENBQUMsQ0FBQztBQUN4RCxDQUFDO0FBRkQsa0NBRUM7QUFFWSxRQUFBLFNBQVMsR0FBRztJQUN2QjtRQUNFLEVBQUUsRUFBRSxPQUFPO1FBQ1gsSUFBSSxFQUFFLE9BQU87UUFDYixHQUFHLEVBQUUsU0FBUztRQUNkLE1BQU0sRUFBRSxLQUFLO0tBQ2Q7SUFDRDtRQUNFLEVBQUUsRUFBRSxPQUFPO1FBQ1gsSUFBSSxFQUFFLE9BQU87UUFDYixHQUFHLEVBQUUsU0FBUztRQUNkLE1BQU0sRUFBRSxJQUFJO0tBQ2I7SUFDRDtRQUNFLEVBQUUsRUFBRSxRQUFRO1FBQ1osSUFBSSxFQUFFLFFBQVE7UUFDZCxHQUFHLEVBQUUsU0FBUztRQUNkLE1BQU0sRUFBRSxLQUFLO0tBQ2Q7SUFDRDtRQUNFLEVBQUUsRUFBRSxXQUFXO1FBQ2YsSUFBSSxFQUFFLFdBQVc7UUFDakIsR0FBRyxFQUFFLFNBQVM7UUFDZCxNQUFNLEVBQUUsSUFBSTtLQUNiO0lBQ0Q7UUFDRSxFQUFFLEVBQUUsT0FBTztRQUNYLElBQUksRUFBRSxPQUFPO1FBQ2IsR0FBRyxFQUFFLFNBQVM7UUFDZCxNQUFNLEVBQUUsS0FBSztLQUNkO0lBQ0Q7UUFDRSxFQUFFLEVBQUUsV0FBVztRQUNmLElBQUksRUFBRSxXQUFXO1FBQ2pCLEdBQUcsRUFBRSxTQUFTO1FBQ2QsTUFBTSxFQUFFLElBQUk7S0FDYjtJQUNEO1FBQ0UsRUFBRSxFQUFFLFNBQVM7UUFDYixJQUFJLEVBQUUsYUFBYTtRQUNuQixNQUFNLEVBQUUsSUFBSTtLQUNiO0lBQ0Q7UUFDRSxFQUFFLEVBQUUsUUFBUTtRQUNaLElBQUksRUFBRSxRQUFRO1FBQ2QsR0FBRyxFQUFFLFNBQVM7UUFDZCxNQUFNLEVBQUUsSUFBSTtLQUNiO0lBQ0Q7UUFDRSxFQUFFLEVBQUUsT0FBTztRQUNYLElBQUksRUFBRSxPQUFPO1FBQ2IsR0FBRyxFQUFFLFNBQVM7UUFDZCxNQUFNLEVBQUUsSUFBSTtLQUNiO0lBQ0Q7UUFDRSxFQUFFLEVBQUUsVUFBVTtRQUNkLElBQUksRUFBRSxVQUFVO1FBQ2hCLEdBQUcsRUFBRSxTQUFTO1FBQ2QsTUFBTSxFQUFFLElBQUk7S0FDYjtDQUNGLENBQUMifQ==